export const Crosshair = ({ className = "", size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
  >
    <circle cx="12" cy="12" r="6.5" />
    <path d="M12 0v8M12 16v8M0 12h8M16 12h8" />
  </svg>
);

export const CropCorners = ({ color = "#2a2a2a" }) => (
  <>
    {[
      "top-0 left-0 border-t border-l",
      "top-0 right-0 border-t border-r",
      "bottom-0 left-0 border-b border-l",
      "bottom-0 right-0 border-b border-r",
    ].map((pos) => (
      <span
        key={pos}
        aria-hidden="true"
        className={`pointer-events-none absolute h-4 w-4 ${pos}`}
        style={{ borderColor: color }}
      />
    ))}
  </>
);

export const CmykBar = ({ className = "" }) => (
  <div className={`flex h-[3px] w-full ${className}`} aria-hidden="true">
    <span className="flex-1" style={{ background: "#00AEEF" }} />
    <span className="flex-1" style={{ background: "#EC008C" }} />
    <span className="flex-1" style={{ background: "#FFF200" }} />
    <span className="flex-1" style={{ background: "#0A0A0A" }} />
  </div>
);

export const SectionLabel = ({ index, children, tone = "dark" }) => (
  <div
    className={`flex items-center gap-4 ${
      tone === "dark" ? "text-neutral-500" : "text-neutral-500"
    }`}
  >
    <span className="label-mono" style={{ color: "var(--ng-red)" }}>
      {index}
    </span>
    <span className="h-px w-10 bg-current opacity-40" />
    <span className="label-mono">{children}</span>
  </div>
);

export const RulerStrip = ({ className = "", color = "currentColor" }) => (
  <div
    aria-hidden="true"
    className={`rule-ticks h-2 w-full opacity-40 ${className}`}
    style={{ color }}
  />
);
